import { useCallback } from 'react'

export interface UseContentBriefBlockActionsProps {
  comment?: string
  draftComment: string
  isEditing: boolean
  setIsEditing: (value: boolean) => void
  setDraftComment: (value: string) => void
  onCommentChange: (comment: string | undefined) => void
}

export interface UseContentBriefBlockActionsReturn {
  handleBlockClick: () => void
  handleSave: () => void
  handleCancel: () => void
  handleDelete: () => void
}

export const useContentBriefBlockActions = ({
  comment,
  draftComment,
  isEditing,
  setIsEditing,
  setDraftComment,
  onCommentChange,
}: UseContentBriefBlockActionsProps): UseContentBriefBlockActionsReturn => {
  const handleBlockClick = useCallback(() => {
    if (!isEditing) {
      setDraftComment(comment ?? '')
      setIsEditing(true)
    }
  }, [isEditing, comment, setDraftComment, setIsEditing])

  const handleSave = useCallback(() => {
    const trimmed = draftComment.trim()
    onCommentChange(trimmed || undefined)
    setIsEditing(false)
  }, [draftComment, onCommentChange, setIsEditing])

  const handleCancel = useCallback(() => {
    setDraftComment(comment ?? '')
    setIsEditing(false)
  }, [comment, setDraftComment, setIsEditing])

  const handleDelete = useCallback(() => {
    onCommentChange(undefined)
    setDraftComment('')
    setIsEditing(false)
  }, [onCommentChange, setDraftComment, setIsEditing])

  return { handleBlockClick, handleSave, handleCancel, handleDelete }
}
